<template>
  <!-- 0306 style 추가 -->
  <el-tree style="text-align:left" class="tree-editor" ref="tree" :data="treeData" node-key="treeKey" :render-content="renderContent" :props="defaultProps" default-expand-all @node-click="onClickNode" :expand-on-click-node="false" highlight-current :filter-node-method="filterNode">
  </el-tree>
</template>

<script>
import ServerSettingAPI from '@/api/settings/server/server-settings';
import TreeFilter from '@/mixins/tree/filter';
import { defaultProps } from '@/constants/tree';
import isEmpty from 'lodash/isEmpty';

export default {
  name: 'WMajorProcTypeTree',
  mixins: [TreeFilter],
  props: {
  },
  data() {
    return {
      treeData: [],
      defaultProps,
    };
  },
  methods: {
    loadTree() {
      const me = this;
      ServerSettingAPI.getMajorProcessTreeList().then((response) => {
        if (response.data.success) {
          this.treeData = response.data.children;
          this.$nextTick(() => {
            if (!isEmpty(this.treeData) && this.treeData.length > 0) {
              const rootTreeKey = me.treeData[0].treeKey;
              const root = me.$refs.tree.getNode(rootTreeKey);
              this.$refs.tree.setCurrentKey(root);
              me.onClickNode(this.$refs.tree.getCurrentNode());
            }
          });
        }
      });
    },
    getTree() {
      return this.$refs.tree;
    },
    onClickNode(data, node) {
      this.$emit('clickNode', data, node);
    },
    /**
     * [renderContent 자동 등록 프로세스 템플릿 트리의 depth에 따라 추가 / 수정 / 삭제 아이콘을 달리한다.]
     * @author yelim
     * @param  {[type]} h    [description]
     * @param  {[type]} node [description]
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    renderContent(h, { node, data }) {
      if (data.depth === 1) {
        return (
          <span class="el-tree-node__label" >
            <span>
              <span class="tree-node-edit-icon content-margin-r" on-click={() => this.$emit('nodeAddType', data, node)}>
                <i class="fas fa-plus-circle"></i>
              </span>
              <span>{data.label}</span>
            </span>
          </span>
        );
      } else if (data.depth === 2) {
        return (
          <span class="el-tree-node__label" >
            <span>
              <span class="tree-node-edit-icon mini content-margin-r">
                <span class="icon-margin-r" on-click={() => this.$emit('nodeUpdateType', data, node)}><i class="fas fa-pen"></i></span>
                <span class="icon-margin-r" on-click={() => this.$emit('nodeAddType', data, node)}><i class="far fa-plus-circle"></i></span>
                <span on-click={() => this.$emit('nodeDeleteType', data, node)}><i class="far fa-minus-circle"></i></span>
              </span>
              <span>{data.label}</span>
            </span>
          </span>
        );
      } else if (data.depth === 3) {
        return (
          <span class="el-tree-node__label" >
            <span>
              <span class="tree-node-edit-icon mini content-margin-r">
                <span class="icon-margin-r" on-click={() => this.$emit('nodeUpdateType', data, node)}><i class="far fa-pen"></i></span>
                <span on-click={() => this.$emit('nodeDeleteType', data, node)}><i class="far fa-minus-circle"></i></span>
              </span>
              <span>{data.label}</span>
            </span>
          </span>
        );
      }
      return (
        <span class="el-tree-node__label" >
          <span>
            <span class="tree-node-edit-icon mini" style="margin-right:5px;">
              <span class="icon-margin-r" on-click={() => this.append(data)}><i class="far fa-pen"></i></span>
              <span on-click={() => this.remove(node, data)}><i class="far fa-minus-circle"></i></span>
            </span>
            <span>{data.label}</span>
          </span>
        </span>
      );
    },
  },
};
</script>

<style>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/server/ProcessSettings/MajorProcessRegistView/component/MajorProcTypeTree.vue